<script lang="ts">
	//UI
	//Image
	import closeBtn from "@hitit/hub/src/assets/Icons/closeBtn.png";
	//Utils
	import { t, store, api } from "@hitit/hub/src/stores";
	import StepTwoPayment from "./StepTwoPayment.svelte";
	import ComponentLoading from "@hitit/hub/src/v7/components/common/ComponentLoading.svelte";
	import type { PaymentTransactionData } from "@hitit/api";

	export let paymentTransactionDto: PaymentTransactionData | undefined;
	export let addPaymentModalCloseHandler: () => void;
	export let selectedPaymentMethod: string | undefined;
	export let loading = false;
	export let clickType = "";
	export let step: number = 2;
	
	let paymentMethod = "card";
</script>

<div class="modal-background" t-id="AddPaymentModal">
	{#if step === 1}
		<div class="step-one modal">
			<img
				class="modal-close"
				src={closeBtn}
				alt="close"
				on:click={addPaymentModalCloseHandler}
			/>
			<div class="step-one-payment-box">
				<span class="title">{$t("hub.order.add_payment")}</span>
				<span class="payment-method"
					>{$t("hub.order.select_payment_method_to_add")}</span
				>
				<div class="btn-widget">
					<div
						class="cash"
						class:paymentMethod={paymentMethod === "cash"}
						on:click={() => (paymentMethod = "cash")}
					>
						<span>{$t("hub.order.payment_type.cash")}</span>
					</div>
					<div
						class="card"
						class:paymentMethod={paymentMethod === "card"}
						on:click={() => (paymentMethod = "card")}
					>
						<span>{$t("hub.order.payment_type.card")}</span>
					</div>
				</div>
				<div class="next-btn" on:click={() => (step = 2)}>
					{$t("global.next")}
				</div>
			</div>
		</div>
	{:else}
		{#if loading}
			<!-- <ComponentLoading coverMode /> -->
		{/if}
		<div class="step-two modal">
			<div class="modal-wrapper">
				<img
					class="modal-close"
					src={closeBtn}
					alt="close"
					on:click={addPaymentModalCloseHandler}
				/>
				<StepTwoPayment
					bind:step={step}
					paymentMethod={paymentMethod}
					paymentTransactionDto={paymentTransactionDto}
					selectedPaymentMethod={selectedPaymentMethod}
					clickType={clickType}
					on:ADD_CARD_PAYMENT
				/>
			</div>
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.modal-background {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(70, 71, 75, 0.7);
		z-index: 10;
	}

	.modal {
		position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		background-color: white;
		border-radius: 5px;

		.modal-wrapper {
			width: 100%;
			height: 100%;
			overflow-x: hidden;
		}

		.modal-close {
			position: absolute;
			top: -40px;
			right: 0px;
			width: 30px;
			height: 30px;
			cursor: pointer;
		}
	}
	.step-one {
		width: 320px;
		height: 197px;
		padding: 15px 10px;

		.step-one-payment-box {
			display: flex;
			flex-direction: column;
			width: 100%;

			.title {
				@include appleAdjustTextForSize(20);
				color: #46474b;
				font-weight: 550;
				margin-bottom: 30px;
			}
			.payment-method {
				@include appleAdjustTextForSize(16);
				color: #46474b;
				margin-bottom: 15px;
			}
			.btn-widget {
				display: flex;
				gap: 10px;
				margin-bottom: 20px;

				div {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 97px;
					height: 31px;
					border-radius: 20px;
					border: 1px solid #bcbfc3;
					color: #46474b;
					cursor: pointer;

					&.paymentMethod {
						background-color: #6d6f76;
						color: white;
					}

					span {
						@include appleAdjustTextForSize(16);
						@include heightRelativeToFontSize(16);
						font-weight: 400;
					}
				}
			}
			.next-btn {
				@include appleAdjustTextForSize(16);
				font-weight: 400;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 40px;
				background-color: #6591fa;
				color: white;
				border-radius: 5px;
				cursor: pointer;
			}
		}
	}
	.step-two {
		width: 320px;
		height: 630px;
	}
	@include DesktopSize {
		.modal {
			.modal-close {
				top: 0;
				right: -60px;
				width: 40px;
				height: 40px;
			}
		}
		.step-one {
			width: 740px;
			height: 210px;
			padding: 30px;

			.step-one-payment-box {
				.title {
					@include appleAdjustTextForSize(30, false);
				}
				.payment-method {
					@include appleAdjustTextForSize(16, false);
				}
				.btn-widget {
					div {
						width: 110px;
						height: 40px;

						span {
							@include appleAdjustTextForSize(16, false);
							@include heightRelativeToFontSize(20);
						}
					}
				}
				.next-btn {
					@include appleAdjustTextForSize(16, false);
				}
			}
		}
		.step-two {
			width: 65%;
			height: 90%;
		}
	}
</style>
